import { RightFooterTALogos } from "../Footer/FooterTA";
import styles from "./CheckoutFooter.module.scss";

interface Props {
  isFullWidth?: boolean;
}
export default function CheckoutFooter({ isFullWidth }: Props) {
  const confidenceText = [
    {
      header: "Top Tour Operator on TripAdvisor",
      text: "With more than 10,000 traveler reviews and awarded NO.1 travel experience on TripAdvisor, we are confident you will enjoy our local tours.",
    },
    {
      header: "Secure Payment",
      text: "You can pay by credit cards or Paypal. MagicalTrip utilizes an encrypted payment system through SSL for secure communicationwithout retaining any card details",
    },
    {
      header: "Lowest Price Guarantee",
      text: "We promise lowest price guarantee to satisfy any tours.",
    },
  ];
  return (
    <footer
      className={styles.CheckoutFooter}
      style={isFullWidth ? { justifyContent: "center" } : null}
    >
      <div
        className={styles.CheckoutFooterWrapper}
        style={isFullWidth ? null : { maxWidth: 675 }}
      >
        <p className={styles.ConfidenceTitle}>Book with Confidence</p>
        {confidenceText.map((c, index) => {
          return (
            <div className={styles.ConfidencePoints} key={index}>
              <svg
                width="22"
                height="16"
                viewBox="0 0 22 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.49994 12.1913L2.63494 7.50007L0.978271 9.08632L7.49994 15.3751L21.4999 1.87507L19.8549 0.288818L7.49994 12.1913Z"
                  fill="#00BFA5"
                />
              </svg>

              <div className={styles.ConfidenceText}>
                <strong>{c.header}</strong>
                <p>{c.text}</p>
              </div>
            </div>
          );
        })}
        <RightFooterTALogos />

        <div className={styles.FooterSupport}>
          <p className={styles.QuestionsTitle}>Any Questions?</p>
          <p>
            If you have any concerns or questions before purchasing the tour,
            please feel free to contact us via the form.
          </p>
          <p>(Business Hours: MON-SUN 10:00AM-7:00PM)</p>
          <a
            href="/contact-us?ref=faq"
            target="_blank"
            className={styles.SupportBtn}
          >
            Contact Form
          </a>
        </div>

        <ul className={styles.FooterSiteLinks}>
          <li>
            <a href="/about-us" target="_blank">
              About Us
            </a>
          </li>
          <li>
            <a href="/terms-of-service" target="_blank">
              Terms of Service
            </a>
          </li>
          <li>
            <a href="/privacy-policy" target="_blank">
              Privacy Policy
            </a>
          </li>
          <li>
            <a href="/external-transmission-rule" target="_blank">
              External Transmission Rule
            </a>
          </li>
          <li>
            <a
              href="/Standard_General_Conditions_of_Travel_Agency_Business_For_MT_Web_Site.pdf"
              target="_blank"
            >
              Standard General Conditions
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
}
